export function getMembershipIdsCount(
  membershipIds: string[],
): Record<string, number> {
  const idsCount: Record<string, number> = {};
  membershipIds.forEach((element) => {
    idsCount[element] = (idsCount[element] || 0) + 1;
  });
  return idsCount;
}
